import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TitleBarParams, TitleBarService } from '../../../redux/services/title-bar.service';
import { customerConfig } from '@uxdf/direct-shared-lib';
import { select, Store } from '@ngrx/store';

@Component({
  standalone: false,
  selector: 'app-account-page',
  templateUrl: './account-page.component.html'
})
export class AccountPageComponent implements OnInit, OnDestroy {
  titleBarParams: Observable<TitleBarParams>;

  isSnow = false;
  private customerConfigSubscription: Subscription;

  constructor(private readonly titleBarService: TitleBarService, private readonly store: Store) {}

  ngOnInit() {
    this.titleBarParams = this.titleBarService.getUpdate();
    this.customerConfigSubscription = this.store.pipe(
      select(customerConfig)).subscribe(response => {
      this.isSnow = response.customerConfig.is_snow;
    });
  }

  ngOnDestroy() {
    if (this.customerConfigSubscription) {
      this.customerConfigSubscription.unsubscribe();
    }
  }
}